import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";

import { GET_RELATED_PRODUCTS } from "../../../../services/graphql-query";
import { CircularProgressCustom } from "../CircularProgressCustom";
import Products from "../Products";

export default function RelatedProducts({ totalProducts, collectionId }) {
    const params = useParams();

    const {
        loading: relatedProductsLoading,
        error: relatedProductsError,
        data: relatedProducts,
    } = useQuery(GET_RELATED_PRODUCTS, {
        variables: { id: collectionId, productName: params.collectionName },
    });

    return (
        <div className="my-4">
            <h2 className="text-uppercase text-center">Related Products</h2>

            {relatedProductsLoading && <CircularProgressCustom />}

            {relatedProductsError && (
                <p className="lead text-center">
                    A server error has occurred. We cannot display related
                    products
                </p>
            )}
            {(function () {
                if (relatedProducts) {
                    if (
                        relatedProducts.collection.data.attributes.products.data
                            .length === 0
                    )
                        return (
                            <p className="lead text-center">
                                There are no related products in this collection
                                yet
                            </p>
                        );
                    else
                        return (
                            <Products
                                products={
                                    relatedProducts.collection.data.attributes
                                        .products.data
                                }
                                justifyContent="justify-content-center"
                            />
                        );
                }
            })()}
        </div>
    );
}
